import React from 'react';
import './OrangeSpinner.css';

interface Props {
  /**
   * Inline: ocupa o espaço de quem o hospeda, em vez da altura da janela.
   *
   * ⚠️ O container padrão tem `height: 100vh` porque nasceu para tela cheia (callback do Google).
   * Dentro de um cartão isso empurraria o layout inteiro — daí a variante, em vez de um segundo
   * componente com o mesmo desenho.
   */
  inline?: boolean;
  /** Menor, para caber onde o valor de um indicador apareceria. */
  pequeno?: boolean;
  /** Anunciado por leitor de tela. O padrão serve à maioria dos usos. */
  rotulo?: string;
}

const OrangeSpinner: React.FC<Props> = ({ inline, pequeno, rotulo = 'Carregando' }) => {
  return (
    <div
      className={`spinner-container${inline ? ' spinner-container-inline' : ''}`}
      role="status"
      aria-live="polite"
      aria-label={rotulo}
    >
      <div className={`orange-spinner${pequeno ? ' orange-spinner-pequeno' : ''}`} />
    </div>
  );
};

export default OrangeSpinner;
